(function ensure_dialog_css_once() {
	if (!jQuery('.js-yalwa_dialog_shared_css').length) {
		const link = document.createElement('link');
		link.className = 'js-yalwa_dialog_shared_css';
		link.rel = 'stylesheet';
		link.href = yalwa.basics.static_url('css') + 'web_components/dialog.css';
		document.head.appendChild(link);
	}
})();

class YalwaDialog extends HTMLElement {
	constructor() {
		super();
		this.$dialog = null;
		this.event_namespace = 'dialog_ns_' + yalwa.basics.create_uuid();
	}
	
	static get observedAttributes() {
		return ['open', 'hide-close-button', 'light-dismiss'];
	}
	
	connectedCallback() {
		this.render();
		const ns = '.' + this.event_namespace;
		
		this.$dialog = jQuery('.js-ywc_dialog', this);
		// wire up minimal behavior
		this.$dialog.find('.js-close').on('click' + ns, () => this.close());
		this.$dialog.on('close' + ns, () => this.removeAttribute('open'));
		this.$dialog.on('click' + ns, (ev) => {
			if (this.hasAttribute('light-dismiss') && ev.target === this.$dialog[0]) {
				this.close();
			}
		});
		this.$dialog.on('keydown' + ns, (ev) => {
			if (ev.key === 'Escape' && this.hasAttribute('hide-close-button')) {
				ev.preventDefault();
				ev.stopPropagation();
			}
		});
		
		jQuery(this).removeClass('invisible');
		if(this.hasAttribute('show-immediately')) {
			this.show();
		};
	}
	
	disconnectedCallback() {
		if (this.$dialog) {
			this.$dialog.off('.' + this.event_namespace);
		}
	}
	
	attributeChangedCallback(name, oldV, newV) {
		if (!this.$dialog) {
			return;
		}
		if (name === 'open' && newV === null && this.$dialog[0].open) {
			this.close();
		}
	}
	
	
	show() {
		this.$dialog[0].showModal();
		yalwa.basics.scroll_lock();
	}
	
	close() {
		if (this.$dialog[0].open) {
			yalwa.basics.scroll_unlock();
			this.$dialog[0].close();
		}
	}
	
	render() {
		const hide_close = this.hasAttribute('hide-close-button');
		const modifier = this.hasAttribute('modifier') ? this.getAttribute('modifier') : '';
		const close_icon = this.getAttribute('close-icon')
			? yalwa.basics.static_url('images') + this.getAttribute('close-icon')
			: yalwa.basics.static_url('images') + 'yimage/31/1431.svg';
		this.innerHTML = `
<dialog class="ywc_dialog${modifier ? ` ywc_dialog--${modifier}` : ''} js-ywc_dialog">
  ${!hide_close ? `<button class="ywc_dialog__close js-close" aria-label="Close"><img loading="lazy" src="${close_icon}" class="yimage" width="28" height="28"></button>` : ''}
  ${this.innerHTML}
</dialog>`;
	}
}

customElements.define('yalwa-dialog', YalwaDialog);